import { LineChart, PieChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CoinIcon } from "../../Assets/svgs/CoinIcon";
import { Loader } from "../../Common/Loader";
import { getCountMetrics } from "../../Redux/Slice/Dashboard/AdminDashboard/GetCountMetricsSlice";
import { getRevenueSummary } from "../../Redux/Slice/Dashboard/AdminDashboard/GetRevenueSummarySlice";
import { getTotalAmountReceived } from "../../Redux/Slice/Dashboard/AdminDashboard/GetTotalAmountReceivedSlice";
import { getTotalCustomersCount } from "../../Redux/Slice/Dashboard/AdminDashboard/GetTotalCustomersSice";
import { getCreditUsedByCustomer } from "../../Redux/Slice/Dashboard/AdminDashboard/GetCreditUsedByCustomerSlice";
import DollarCoinIcon from "../../Assets/svgs/DollarCoinIcon";
import { CustomerdashboardIcon } from "../../Assets/svgs/CustomerdashboardIcon";

export const AdminDashboard = () => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const [countMetricsPeriod, setCountMetricsPeriod] = useState("currentMonth");
  const [amountReceivedYear, setAmountReceivedYear] = useState(currentYear);
  const [creditsUsedMetricsPeriod, setCreditsUsedMetricsPeriod] =
    useState(currentYear);
  const [revenueSummaryYear, setRevenueSummaryYear] = useState(currentYear);

  const { totalCustomersCountData, loading: isLoadingTotalCustomersCountData } =
    useSelector((s) => s?.totalCustomers);

  const { totalAmountReceivedData, loading: isLoadingTotalAmountReceivedData } =
    useSelector((s) => s?.totalAmountReceived);

  const { creditUsedByCustomerData, loading: isLoadingCreditUsedByCustomer } =
    useSelector((s) => s?.creditUsedByCustomer);

  const { revenueSummaryData, loading: isLoadingRevenueSummaryData } =
    useSelector((s) => s?.revenueSummary);

  const userData = JSON.parse(localStorage.getItem("userData"));

  const userDropdwon = [
    { label: "All", value: "all" },
    { label: "Customers", value: "company" },
    { label: "Individuals", value: "individual" },
  ];
  const yearDropdwon = [
    { label: "Current Year", value: currentYear },
    { label: currentYear - 1, value: currentYear - 1 },
    { label: currentYear - 2, value: currentYear - 2 },
    { label: currentYear - 3, value: currentYear - 3 },
    { label: "All", value: "all" },
  ];
  const amountDropdwon = [
    { label: "Current Year", value: currentYear },
    { label: currentYear - 1, value: currentYear - 1 },
    { label: currentYear - 2, value: currentYear - 2 },
    { label: currentYear - 3, value: currentYear - 3 },
    { label: "All", value: "all" },
  ];
  const pieCHartDropdwon = [
    { label: "Current Month", value: "currentMonth" },
    { label: "Last 3 months", value: "last3months" },
    { label: "Current Year", value: "currentYear" },
    { label: "All", value: "all" },
  ];
  const xLabels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const pData =
    revenueSummaryData &&
    revenueSummaryData?.data &&
    Array.isArray(revenueSummaryData?.data?.metrics)
      ? revenueSummaryData?.data?.metrics?.map((metrics) => metrics?.value)
      : [];

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format;

  useEffect(() => {
    dispatch(getTotalCustomersCount());
    dispatch(getCreditUsedByCustomer());
  }, []);

  useEffect(() => {
    dispatch(getTotalAmountReceived(amountReceivedYear));
  }, [amountReceivedYear]);

  useEffect(() => {
    dispatch(getRevenueSummary(revenueSummaryYear));
  }, [revenueSummaryYear]);

  return (
    <div className="page__body">
      {isLoadingTotalCustomersCountData ||
      isLoadingTotalAmountReceivedData ||
      isLoadingRevenueSummaryData ||
      isLoadingCreditUsedByCustomer ? (
        <Loader />
      ) : null}
      <div className="dashboardWrap">
        <div className="dashboardWrap__head dashboardWrap__head__3">
          <div className="dashboardWrap__head__item">
            <div className="card card--sad">
              <div className="card__header">
                <h3 className="title">Total Customers</h3>
              </div>
              <div className="card__info">
                <div className="icon">
                  <CoinIcon />
                </div>
                <div className="info">
                  <h4 className="value">
                    {totalCustomersCountData?.data?.totalCustomers}{" "}
                    {totalCustomersCountData?.data?.change > 0 ? (
                      <span>+{totalCustomersCountData?.data?.change}</span>
                    ) : totalCustomersCountData?.data?.change < 0 ? (
                      <span className="red">
                        {totalCustomersCountData?.data?.change}
                      </span>
                    ) : null}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card card--sad">
              <div className="card__header">
                <h3 className="title">Amount Received</h3>
                <div className="form__Field">
                  <select
                    id="AllCustomers"
                    value={amountReceivedYear}
                    onChange={(e) => setAmountReceivedYear(e.target.value)}
                    className="form__select form__select--sm"
                  >
                    <option disabled>-Select-</option>
                    {amountDropdwon
                      ? amountDropdwon.map((year) => (
                          <option value={year.value}>{year.label}</option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
              <div className="card__info">
                <div className="icon">
                  <DollarCoinIcon />
                </div>
                <div className="info">
                  <h4 className="value">
                    ${totalAmountReceivedData?.data?.value}{" "}
                    {totalAmountReceivedData?.data?.totalAmountThisYear > 0 ? (
                      <span>
                        +${totalAmountReceivedData?.data?.totalAmountThisYear}
                      </span>
                    ) : totalAmountReceivedData?.data?.totalAmountThisYear <
                      0 ? (
                      <span className="red">
                        {totalAmountReceivedData?.data?.totalAmountThisYear}
                      </span>
                    ) : null}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card card--sad">
              <div className="card__header">
                <h3 className="title">Average Credits Used By Customers </h3>
              </div>
              <div className="card__info">
                <div className="icon">
                  <CustomerdashboardIcon />
                </div>
                <div className="info">
                  <h4 className="value">
                    {creditUsedByCustomerData?.data?.todayAverageCreditsUsed}{" "}
                    {creditUsedByCustomerData?.data?.difference > 0 ? (
                      <span>+{creditUsedByCustomerData?.data?.difference}</span>
                    ) : creditUsedByCustomerData?.data?.difference < 0 ? (
                      <span className="red">
                        {creditUsedByCustomerData?.data?.difference}
                      </span>
                    ) : null}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboardWrap__body">
          {/* <div className="cardRow cardRow__2">
            <div className="col">
              <div className="card radius_0">
                <div className="card__header">
                  <h3 className="title">Count Metrics</h3>
                  <div className="form__Field">
                    <select
                      id="AllCustomers"
                      className="form__select form__select--sm"
                      value={countMetricsPeriod}
                      onChange={(e) => setCountMetricsPeriod(e.target.value)}
                    >
                      <option disabled value="1" selected="">
                        -Select-
                      </option>
                      {pieCHartDropdwon
                        ? pieCHartDropdwon.map((userType) => {
                            return (
                              <option value={userType.value}>
                                {userType.label}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="card__body">
                  <div className="graphInfo">
                    <div className="graphInfo__graph">
                      <PieChart
                        series={[
                          {
                            data:
                              countMetricsData &&
                              countMetricsData?.data &&
                              Array.isArray(countMetricsData?.data?.metrics)
                                ? countMetricsData?.data?.metrics
                                : [],
                            innerRadius: 60,
                            paddingAngle: 5,
                            marginLeft: 0,
                          },
                        ]}
                        width={600}
                        height={300}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card radius_0">
                <div className="card__header">
                  <h3 className="title">Credits Used Metrics</h3>
                  <div className="form__Field">
                    <select
                      id="AllCustomers"
                      className="form__select form__select--sm"
                      value={creditsUsedMetricsPeriod}
                      onChange={(e) =>
                        setCreditsUsedMetricsPeriod(e.target.value)
                      }
                    >
                      <option disabled value="1" selected="">
                        -Select-
                      </option>
                      {pieCHartDropdwon
                        ? pieCHartDropdwon.map((userType) => {
                            return (
                              <option value={userType.value}>
                                {userType.label}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="card__body">
                  <div className="graphInfo">
                    <div className="graphInfo__graph">
                      <PieChart
                        series={[
                          {
                            data: [
                              { id: 0, value: 10, label: "series A" },
                              { id: 1, value: 15, label: "series B" },
                              { id: 2, value: 20, label: "series C" },
                            ],
                            innerRadius: 60,
                            paddingAngle: 5,
                          },
                        ]}
                        width={500}
                        height={300}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {userData?.role?.name == "superadmin" ? (
            <div className="cardRow">
              <div className="col">
                <div className="card radius_0">
                  <div className="card__header">
                    <h3 className="title">Revenue Summary</h3>
                    <div className="form__Field">
                      <select
                        id="AllCustomers"
                        className="form__select form__select--sm"
                        value={revenueSummaryYear}
                        onChange={(e) => setRevenueSummaryYear(e.target.value)}
                      >
                        <option disabled value="1" selected="">
                          -Select-
                        </option>
                        {yearDropdwon
                          ? yearDropdwon.map((year) => (
                              <option value={year.value}>{year.label}</option>
                            ))
                          : ""}
                      </select>
                    </div>
                  </div>
                  <div className="card__body">
                    <LineChart
                      height={300}
                      colors={["#8b58f1"]}
                      series={[
                        { data: pData, valueFormatter: currencyFormatter },
                      ]}
                      xAxis={[
                        {
                          scaleType: "point",
                          data: xLabels,
                          label: "Month",
                        },
                      ]}
                      yAxis={[
                        {
                          label: "Revenue ($)",
                        },
                      ]}
                      sx={{
                        ".MuiChartsAxis-label": {
                          transform: "translateX(-38px) !important",
                        },
                        padding:'11px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
